/**
=========================================================
* Soft UI Dashboard PRO React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Soft UI Dashboard PRO React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that contains other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

import Profile from "pages/profile";
import Setting from "pages/setting";
import Dashboard from "pages/dashboard";
import EditProfile from "pages/profile/edit-profile";
import MessagesPage from "pages/messages";
import BlogPage from "pages/blog/blog";
import UserBlogs from "pages/blog/userblogs";
import { ContactUsPage } from "pages/messages/index";
import SearchPage from "pages/search";
import ProjectHomeIndex from "pages/my-projects";
import Calendar from "pages/calendar";

//designer
import ManufacturerList from "pages/de/manufacturer-list";
import ManufacturerDetail from "pages/de/manufacturer-detail";

import ProjectList from "pages/de/project/my-projects";
import CreateProject from "pages/de/project/create-project";
import PublishProject from "pages/de/project/publish-project";
import StyleMaster from "pages/de/styles/list-page";
import StyleDetail from "pages/de/styles/detail";
import Collection from "pages/de/collection/list-page";
import Moodboard from "pages/de/collection/moodboards/moodboard";
import AILabList from "pages/ai";
import TechpackList from "pages/de/styles/techpack-list";
import SharedContentList from "pages/de/share-page/list";
import Portfolio from "pages/de/portfolio";
import PortfolioCollectionDetailPage from "pages/de/portfolio/components/collection-detail";
import Palette from "pages/de/palette";
import ColorDetail from "pages/de/palette/detail";
import SizeChart from "pages/de/size-chart";
import SizeChartDetail from "pages/de/size-chart/detail/sizechartdetail";

//manufacturers
import DesignerList from "pages/ma/designer-list";
import MAProjectList from "pages/ma/project/my-projects";
import MARequestList from "pages/ma/project/requests";

import SavedInterests from "pages/ma/saved-interests";

import AccountBoxIcon from "@mui/icons-material/AccountBox";
import ArrowRight from "components/Icon/ArrowRight";
import HomeIcon from "@mui/icons-material/Home";
import TaskIcon from "@mui/icons-material/Task";
import MessageIcon from "@mui/icons-material/Message";
import PeopleIcon from "@mui/icons-material/People";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import SettingsIcon from "@mui/icons-material/Settings";
import BusinessIcon from "@mui/icons-material/Business";
import InventoryIcon from "@mui/icons-material/Inventory";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import DashboardIcon from "@mui/icons-material/Dashboard";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import RssFeedIcon from "@mui/icons-material/RssFeed";
//import AntdApp from "pages/antd";
import StyleIcon from "@mui/icons-material/Style";
import ListAltIcon from "@mui/icons-material/ListAlt";

import PostListPage from "pages/de/posts";
import ConnectPage from "pages/connect";
import ManageConnectionPage from "pages/connect/manage-connection";
import PostManagementListPage from "pages/de/posts/manage-list";
import CreatePostPage from "pages/de/posts/create";
import NewPortfolioPage from "pages/de/new-portfolio";
import CreatePage from "pages/create";
import OnlineResource from "pages/online-resource";
import FlatSketches from "pages/online-resource/FlatSketches";
import SharedResource from "pages/shared-resource";
import SizeCharts from "pages/online-resource/SizeCharts";
import FashionLabList from "pages/fashionlab/list";
import FashionLabPage from "pages/fashionlab";
import MaterialLibrary from "pages/de/material-library";

import UnionwearProjectPage from "pages/unionwear/project-page";
import UnionwearProductPage from "pages/unionwear/product-page";
import UnionwearDetailViewProductPage from "pages/unionwear/components/DetailViewProduct";

import UnionwearMaterialPage from "pages/unionwear/material-page";
import ImportProductPage from "pages/unionwear/components/ImportProductPage";

import ProjectListPage from "pages/unionwear/project-page";

import ProjectDetailPage from "pages/unionwear/components/ProjectDetailPage";

const routes = [
  //----------------------------------------------------------------
  //Dashboard Route (Dashboard)
  //----------------------------------------------------------------
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    route: "/dashboard",
    component: <Dashboard />,
    noCollapse: true,
  },

  {
    type: "collapse",
    name: "Posts",
    keys: ["explore", "post"],
    collapse: [
      {
        name: "Explore",
        key: "explore",
        component: <PostListPage tabValue="explore" />,
        noCollapse: true,
        route: "/explore",
      },
      {
        name: "Following",
        key: "following",
        component: <PostListPage tabValue="following" />,
        noCollapse: true,
        route: "/explore/following",
      },
      {
        name: "For You",
        key: "for-you",
        component: <PostListPage tabValue="for-you" />,
        noCollapse: true,
        route: "/explore/for-you",
      },
      {
        name: "Create Post",
        key: "create-posts",
        component: <CreatePostPage />,
        noCollapse: true,
        route: "/post/create",
      },
    ],
  },
  {
    type: "collapse",
    name: "Create",
    key: "create",
    hidden: true,
    collapse: [
      {
        name: "AI Lab(Beta)",
        route: "/create/ailab",
        noCollapse: true,
        //account_type: "de",
        fullWidth: true,
        noFooter: true,
        component: <AILabList create={true} />,
      },
      {
        name: "Moodboards",
        route: "/create/moodboard",
        noCollapse: true,
        //account_type: "de",
        fullWidth: true,
        noFooter: true,
        component: <Moodboard />,
      },
      {
        name: "Style",
        key: "style",
        route: "/create/style",
        component: <StyleDetail />,
      },
      {
        name: "Tech Packs",
        key: "tech-pack",
        route: "/create/tech-pack",
        component: <TechpackList create={true} />,
      },
      {
        name: "Post",
        route: "/create/posts",
        noCollapse: true,
        component: <CreatePostPage />,
      },
    ],
  },
  //----------------------------------------------------------------
  //Social Routes (Community)
  //----------------------------------------------------------------
  {
    type: "collapse",
    name: "Connect",
    key: "connect",
    route: "/connect",
    collapse: [
      {
        name: "Designers",
        key: "designers",
        component: <ConnectPage type="de" />,
        noCollapse: true,
        route: "/connect/designers",
      },
      {
        name: "Manufacturers",
        key: "manufacturers",
        component: <ConnectPage type="ma" />,
        noCollapse: true,
        route: "/connect/manufacturers",
      },
    ],
  },

  //----------------------------------------------------------------
  //Workspace Routes (Develop)
  //----------------------------------------------------------------
  {
    type: "collapse",
    name: "Develop",
    keys: ["workspace", "shared-with-me", "setup"],
    icon: <StyleIcon fontSize="small" />,
    collapse: [
      {
        name: "AI Design",
        key: "fashion-lab",
        route: "/workspace/fashion-lab",
        component: <FashionLabPage />,
      },
      {
        name: "Fashion Lab",
        key: "fashion-lab",
        route: "/workspace/fashion-lab/:ailab_id",
        component: <FashionLabPage edit />,
        hidden: true,
      },
      {
        name: "Moodboards",
        route: "/workspace/moodboard",
        noCollapse: true,
        //account_type: "de",
        fullWidth: true,
        noFooter: true,
        component: <Moodboard />,
      },
      {
        name: "Style Master",
        key: "style",
        route: "/workspace/styles-detail",
        component: <StyleDetail />,
      },
      {
        name: "Tech Pack",
        key: "tech-pack",
        route: "/workspace/styles-detail?stage=tech-pack",
        component: <StyleDetail />,
      },
      {
        name: "Collection",
        key: "collections",
        route: "/workspace/collections",
        component: <Collection />,
      },
      {
        name: "Style Library",
        route: "/workspace/styles-master",
        component: <StyleMaster />,
        dividerUp: true,
      },
      {
        name: "Tech Pack Library",
        route: "/workspace/tech-packs",
        component: <TechpackList />,
      },
      {
        name: "Color Library",
        route: "/setup/color-master",
        noCollapse: true,
        //account_type: "de",
        component: <Palette />,
      },
      {
        name: "Size Chart Library",
        route: "/setup/size-master",
        noCollapse: true,
        //account_type: "de",
        component: <SizeChart />,
      },
      {
        name: "Material Library",
        route: "/setup/material-library",
        noCollapse: true,
        //account_type: "de",
        component: <MaterialLibrary />,
      },

      //----------------------------------------------------------------
      //shared with routes
      //----------------------------------------------------------------

      {
        type: "collapse",
        name: "Collaboration",
        key: "shared-with-me",
        route: "/shared-with-me",
        component: <SharedContentList />,
        dividerUp: true,
        noCollapse: true,
      },
      {
        type: "collapse",
        key: "shared-with-me",
        route: "/shared-with-me/styles",
        component: <StyleDetail sharedView={true} />,
        noCollapse: true,
        hidden: true,
      },

      {
        type: "collapse",
        key: "shared-with-me",
        route: "/shared-with-me/collections",
        component: <Collection sharedView={true} />,
        noCollapse: true,
        hidden: true,
      },
      {
        type: "collapse",
        key: "shared-with-me",
        route: "/shared-with-me/moodboards",
        fullWidth: true,
        noFooter: true,
        component: <Moodboard sharedView={true} />,
        noCollapse: true,
        hidden: true,
      },
      {
        type: "collapse",
        key: "shared-with-me",
        route: "/shared-with-me/size-master/:id",
        component: <SizeChartDetail sharedView={true} />,
        noCollapse: true,
        hidden: true,
      },

      {
        type: "collapse",
        key: "setup",
        route: "/setup/color-master/:id",
        component: <ColorDetail />,
        noCollapse: true,
        hidden: true,
      },
      {
        type: "collapse",
        key: "setup",
        route: "/setup/size-master/:id",
        component: <SizeChartDetail />,
        noCollapse: true,
        hidden: true,
      },
      {
        route: "/workspace/edit-project",
        noCollapse: true,
        component: <CreateProject edit={true} />,
        hidden: true,
      },
      {
        route: "/workspace/duplicate-project",
        noCollapse: true,
        component: <CreateProject duplicate={true} />,
        hidden: true,
      },
    ],
  },
  //----------------------------------------------------------------
  //Project Routes (Produce) Designer only
  //----------------------------------------------------------------
  {
    type: "collapse",
    name: "Produce",
    key: "produce",
    route: "/produce/all-projects",
    component: <ProjectHomeIndex stage={"all"} />,
    // projectCount: "all",
    noCollapse: true,
    account_type: "de",
  },

  //----------------------------------------------------------------
  //Job Routes (Job Board) Manufacturer only
  //----------------------------------------------------------------
  {
    type: "collapse",
    name: "Job Board",
    key: "job",
    icon: <StyleIcon fontSize="small" />,
    account_type: "ma",
    collapse: [
      {
        name: "Public Requests",
        key: "requests",
        component: <MARequestList type="public-requests" />,
        noCollapse: true,
        route: "/job/requests",
        //countKey: "unreadRequestCount", //counter keys includes "count","pcount","gcount"
      },
      // {
      //   name: "My Requests",
      //   key: "my-requests",
      //   component: <MARequestList type="my-requests" />,
      //   noCollapse: true,
      //   route: "/job/my-requests",
      // },
      {
        name: "Saved Interests",
        key: "saved-interests",
        component: <MAProjectList tabValue="saved-projects" />,
        noCollapse: true,
        route: "/job/saved-interests",
      },
      {
        name: "My Projects",
        key: "projects",
        component: <MAProjectList tabValue="working-projects" />,
        noCollapse: true,
        route: "/job/my-projects",
      },
    ],
  },
  //----------------------------------------------------------------
  //Resources Routes
  //----------------------------------------------------------------
  {
    type: "collapse",
    name: "Resources",
    route: "resources",
    key: "resource",
    collapse: [
      {
        name: "Flat Sketches",
        route: "/resource/flat-sketches",
        noCollapse: true,
        component: <FlatSketches />,
      },
      {
        name: "Shared Work",
        route: "/resource/shared-work",
        noCollapse: true,
        component: <SharedResource />,
      },
      {
        name: "Size Charts",
        route: "/resource/size-charts",
        noCollapse: true,
        component: <SizeCharts />,
      },
    ],
  },

  {
    type: "collapse",
    name: "Messages",
    key: "messages",
    countKey: "pgcount", //counter keys includes "count","pcount","gcount"
    icon: <MessageIcon fontSize="small" />,
    route: "/messages",
    component: <MessagesPage />,
    noCollapse: true,
    hidden: true,
  },

  //----------------------------------------------------------------
  {
    key: "designers-list",
    route: "/designers-list",
    component: <DesignerList />,
    noCollapse: true,
  },
  {
    name: "Profile",
    key: "profile",
    type: "collapse",
    icon: <AccountBoxIcon fontSize="small" />,
    route: "/profile",
    component: <Profile />,
    noCollapse: true,
    hidden: true,
  },
  {
    type: "collapse",
    name: "Setting",
    key: "setting",
    route: "/setting",
    noCollapse: true,
    component: <Setting />,
    icon: <SettingsIcon fontSize="small" />,
    hidden: true,
  },
  {
    route: "/edit-profile",
    noCollapse: true,
    component: <EditProfile />,
  },

  {
    route: "/designers/publish-project",
    name: "Send Requests",
    noCollapse: true,
    account_type: "de",
    component: <PublishProject />,
  },
  {
    route: "/messages/:inittab",
    noCollapse: true,
    component: <MessagesPage />,
  },
  {
    name: "Create Project",
    account_type: "de",
    key: "projects-create",
    route: "/produce/all-projects/create",
    component: <CreateProject />,
    hidden: true,
  },
  {
    type: "collapse",
    name: "Contact Us",
    key: "contactus",
    countKey: "ccount",
    icon: <WhatsAppIcon fontSize="small" />,
    route: "/contactus",
    component: <ContactUsPage />,
    noCollapse: true,
    hidden: true,
  },
  {
    type: "collapse",
    key: "search",
    route: "/search",
    component: <SearchPage />,
    noCollapse: true,
    hidden: true,
  },
  {
    type: "collapse",
    key: "portfolio",
    route: "/portfolio/:handle",
    component: <Portfolio editable={false} />,
    noCollapse: true,
    hidden: true,
  },
  {
    type: "collapse",
    key: "portfolio",
    route: "/portfolio/:handle/:cid",
    component: <PortfolioCollectionDetailPage />,
    noCollapse: true,
    hidden: true,
  },
  {
    type: "collapse",
    key: "my-portfolio",
    route: "/my-portfolio",
    component: <Portfolio editable={true} />,
    account_type: "de",
    noCollapse: true,
    hidden: true,
  },

  {
    type: "collapse",
    key: "calendar",
    route: "/calendar",
    component: <Calendar />,
    noCollapse: true,
    hidden: true,
  },

  {
    type: "collapse",
    key: "new-post",
    route: "/new-post",
    component: <CreatePostPage />,
    noCollapse: true,
    hidden: true,
  },
  {
    type: "collapse",
    key: "edit-post",
    route: "/edit-post/:postid",
    component: <CreatePostPage edit />,
    noCollapse: true,
    hidden: true,
  },
  {
    type: "collapse",
    key: "portfolio",
    route: "/wall/portfolio",
    component: <NewPortfolioPage editable={true} />,
    noCollapse: true,
    hidden: true,
  },
  {
    type: "collapse",
    key: "portfolio",
    route: "/wall/portfolio/:handle",
    component: <NewPortfolioPage editable={false} />,
    noCollapse: true,
    hidden: true,
  },
  {
    name: "Posts",
    route: "/my-posts",
    noCollapse: true,
    component: <PostManagementListPage />,
  },

  {
    type: "collapse",
    key: "followers",
    route: "/connect/followers",
    component: <ManageConnectionPage tab={"followers"} />,
    noCollapse: true,
    hidden: true,
  },
  {
    type: "collapse",
    key: "following",
    route: "/connect/following",
    component: <ManageConnectionPage tab={"following"} />,
    noCollapse: true,
    hidden: true,
  },
  {
    type: "collapse",
    key: "collaborators",
    route: "/connect/collaborators",
    component: <ManageConnectionPage tab={"collaborators"} />,
    noCollapse: true,
    hidden: true,
  },
  {
    type: "collapse",
    key: "events",
    route: "/connect/events",
    component: <ManageConnectionPage tab={"events"} />,
    noCollapse: true,
    hidden: true,
  },

  //----------------------------------------------------------------
  //Create Routes (Create)
  //----------------------------------------------------------------
  {
    type: "collapse",
    name: "Create",
    key: "create",
    route: "/create",
    component: <CreatePage />,
    noCollapse: true,
    hidden: true,
  },
  {
    type: "collapse",
    name: "Blog",
    route: "/social/blog",
    component: <BlogPage />,
    noCollapse: true,
    hidden: true,
  },
  //----------------------------------------------------------------
  //Unionwear routes
  //----------------------------------------------------------------
  {
    type: "collapse",
    name: "Unionwear",
    key: "unionwear",
    route: "/unionwear",
    noCollapse: true,
    hidden: true,
    component: <ProjectListPage />,
    visible_users: [
      "usr_01HDEM4Q5WYH6A87AGW2FY1656",
      "UpStyled",
      "usr_01GKPWTY39V15SE0H2AB1ZGDAS",
      "usr_01GZESEAT6RSR8F01QTQ7MPX49",
    ], //mitch,admin,kaili37575
  },
  {
    name: "Unionwear Tasks",
    key: "unionwear-task",
    route: "/unionwear/tasks",
    hidden: true,
    component: <ProjectListPage />,
  },
  {
    name: "Unionwear Project Detail",
    key: "unionwear-project-detail",
    route: "/unionwear/tasks/:id",
    hidden: true,
    component: <ProjectDetailPage />,
  },
  {
    name: "Unionwear",
    key: "unionwear-product",
    route: "/unionwear/product",
    hidden: true,
    component: <UnionwearProductPage />,
  },
  {
    name: "Unionwear Product Detail",
    key: "unionwear-product-detail",
    route: "/unionwear/product/:id",
    hidden: true,
    component: <UnionwearDetailViewProductPage />,
  },
  {
    name: "Unionwear Edit Task",
    key: "unionwear-edit-task",
    route: "/unionwear/tasks/edit/:id",
    hidden: true,
    component: <ImportProductPage />,
  },
  {
    name: "Unionwear import Product",
    key: "unionwear-import-product",
    route: "/unionwear/tasks/import-product",
    hidden: true,
    component: <ImportProductPage />,
  },
  {
    name: "Unionwear Material",
    key: "unionwear-material",
    route: "/unionwear/material",
    hidden: true,
    component: <UnionwearMaterialPage />,
  },
];

export default routes;
